import { Typography } from '@mui/material';

import { INode } from '../../Context/FormBuilderContext';

interface ShortTextWidgetProps {
  node: INode;
}

export function ShortTextWidget({ node }: ShortTextWidgetProps) {
  const styles = node?.data?.styles;

  return (
    <>
      {node?.data?.text && (
        <Typography
          style={{
            color: styles.shortText?.color || 'rgb(71, 84, 103)',
            whiteSpace: 'pre-wrap',
            fontSize: `${styles.shortText?.fontSize || 14}px`,
            fontFamily: styles.shortText?.fontFamily || 'Roboto, sans-serif',
            fontWeight: styles.shortText?.isBold ? '700' : '400',
            fontStyle: styles.shortText?.isItalic ? 'italic' : 'normal',
            textDecoration: styles.shortText?.isUnderlined
              ? 'underline'
              : 'none',
            width: '100%',
            textAlign: styles.shortText?.textAlign || 'left',
            lineHeight: '150%',
            letterSpacing: '0.5px',
          }}
        >
          {node.data.text}
        </Typography>
      )}
    </>
  );
}
